import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { api } from "../lib/api";
import { PageTitle } from "../components/site/PageTitle";
import { MonthCalendar } from "../components/site/MonthCalendar";
import { TicketDialog } from "../components/site/TicketDialog";
import { DatesTBD, ShowRow } from "./Home";

export default function Shows() {
  const [concerts, setConcerts] = useState([]);
  const [booked, setBooked] = useState([]);
  const [month, setMonth] = useState(new Date());
  const [pick, setPick] = useState(null);

  useEffect(() => {
    Promise.all([api.concerts(), api.booked()]).then(([c, b]) => {
      setConcerts(c);
      setBooked(b);
      const next = c.find((x) => x.date >= new Date().toISOString().slice(0, 10));
      if (next) setMonth(parseISO(next.date));
    }).catch(() => {});
  }, []);

  const upcoming = concerts.filter((c) => c.date >= new Date().toISOString().slice(0, 10));
  const monthKey = format(month, "yyyy-MM");

  return (
    <>
      <PageTitle kicker="Tour & bookings" title="Concert calendar">
        Tap a green date to get tickets — 0 to 100 per order. Purple dates are private events already booked.
      </PageTitle>
      <section className="px-5 lg:px-12 grid gap-12 xl:grid-cols-[1.5fr_1fr]">
        <MonthCalendar month={month} setMonth={setMonth} concerts={concerts} booked={booked} onPick={setPick} />
        <div>
          <h2 className="font-gothic text-4xl mb-4">Upcoming shows</h2>
          {upcoming.length === 0 && <DatesTBD testid="shows-empty" />}
          {upcoming.map((c) => <ShowRow key={c.id} c={c} onPick={setPick} />)}
          {booked.filter((b) => b.date.startsWith(monthKey)).length > 0 && (
            <div className="mt-10" data-testid="booked-this-month">
              <p className="font-cond uppercase tracking-widest text-sm text-slate-500 mb-3">Booked this month</p>
              {booked.filter((b) => b.date.startsWith(monthKey)).map((b) => (
                <p key={b.id} className="text-[#d8b4fe] text-sm py-1">{b.date} · {b.event_type} · {b.city}</p>
              ))}
            </div>
          )}
        </div>
      </section>
      <TicketDialog concert={pick} onClose={() => setPick(null)} />
    </>
  );
}
